import { render, staticRenderFns } from "./activeYX.vue?vue&type=template&id=28c6e293&"
import script from "./activeYX.vue?vue&type=script&lang=js&"
export * from "./activeYX.vue?vue&type=script&lang=js&"
import style0 from "./activeYX.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports